// L'état du plein écran d'un graphique (voir PleinEcran.tsx), à part du composant : un module
// qui n'exporte que des composants garde le rechargement à chaud de Vite.
import { useCallback, useRef, useState } from 'react'

/** Ouvert ou non, et le bouton « Agrandir » auquel le focus revient à la fermeture.
    `ouvrir` et `fermer` sont STABLES : la fenêtre s'en sert comme dépendances d'effet et comme
    identité (« une seule fenêtre à la fois ») — recréées à chaque rendu, elles relanceraient
    l'effet d'ouverture, qui reprendrait le focus au lecteur. */
export function usePleinEcran() {
  const [ouvert, setOuvert] = useState(false)
  const bouton = useRef<HTMLButtonElement>(null)
  const ouvrir = useCallback(() => setOuvert(true), [])
  const fermer = useCallback(() => setOuvert(false), [])
  return { ouvert, ouvrir, fermer, bouton }
}
